<template>
  <div class="page-container">
    <div
      class="header shader"
      style="box-shadow: 0 0 10px rgba(125, 136, 148, 0.5) !important"
    >
      <a
        href="#"
        class="btn-link toggle-sidebar d-lg-none pg-icon btn-icon-link"
        data-toggle="sidebar"
      >
        menu
      </a>
      <!-- END MOBILE SIDEBAR TOGGLE -->
      <div>
        <div class="brand inline" style="text-align: left; padding-left: 80px">
          <img
            v-if="logo_proyek"
            :src="logo_proyek"
            alt="logo"
            :data-src="logo_proyek"
            :data-src-retina="logo_proyek"
            height="40"
            @error="logo_proyek = null"
          />
        </div>
      </div>
      <div v-if="!is_mobile" class="d-flex align-items-center">
        <h4 style="font-weight: bold">
          {{ nama_proyek }}
        </h4>
      </div>
      <div class="d-flex align-items-center">
        <label
          v-if="isProjectExpire() && !is_mobile"
          class="label label-danger m-0 mr-2"
          ><i class="bi bi-exclamation-circle" />
          {{ project_expire_message }}</label
        >
        <i
          v-if="theme == 'dark-mode'"
          class="bi bi-sun clickable hoverable"
          style="font-size: 20px"
          @click="changeTheme('light-mode')"
        ></i>
        <i
          v-else
          class="bi bi-moon-stars clickable hoverable"
          style="font-size: 20px"
          @click="changeTheme('dark-mode')"
        ></i>
        <!-- START NOTIFICATION LIST -->
        <ul
          class="d-lg-inline-block notification-list no-margin d-lg-inline-block no-style p-l-20 p-r-20"
        >
          <li class="p-r-5 inline">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                id="notification-center"
                @click="toggleNotif"
                class="header-icon btn-icon-link"
                data-toggle="dropdown"
              >
                <i class="bi bi-bell color-custom" style="font-size: 20px" />
                <span v-if="new_notif" class="bubble" />
              </a>
              <!-- START Notification Dropdown -->
              <div
                class="dropdown-menu notification-toggle"
                id="notifDropdownMenu"
                role="menu"
                aria-labelledby="notification-center"
              >
                <!-- START Notification -->
                <div class="notification-panel">
                  <!-- START Notification Body-->
                  <div
                    class="notification-body scrollable"
                    style="position: relative; min-height: 250px"
                  >
                    <div class="col-md-12" align="center">
                      <h4><i class="bi bi-bell"></i> Pemberitahuan</h4>
                    </div>
                    <div v-if="is_loading" class="col-md-12">
                      <loader-component
                        :with_text="true"
                        text="Memuat pemberitahuan"
                      />
                    </div>
                    <div
                      v-else-if="!is_loading && !data_notif"
                      class="notif-content"
                      align="center"
                    >
                      <img src="assets/img/web/notification-empty.png" alt="" />
                      <h4
                        align="center"
                        class="m-b-10"
                        style="margin-top: -35px"
                      >
                        Everything's OK!
                      </h4>
                    </div>
                    <div v-else class="notif-content">
                      <!-- START Notification Item-->
                      <div
                        v-for="(notif, index) in data_notif"
                        :key="'notif-' + index"
                        @click="notifAction(index)"
                        class="notification-item unread clearfix"
                        style="cursor: pointer"
                      >
                        <div class="heading">
                          <div class="row">
                            <div class="col-md-1 p-r-0">
                              <div
                                class="thumbnail-wrapper d24 circular b-white m-r-5 b-a b-white m-t-10 m-r-10"
                              >
                                <i
                                  :class="
                                    icon_sources[notif.source.toLowerCase()] +
                                      ' icon-' +
                                      notif.source.toLowerCase()
                                  "
                                />
                              </div>
                            </div>
                            <div class="col-md-11">
                              <a
                                href="javascript:void(0)"
                                style="
                                  line-height: normal;
                                  display: inline-flex;
                                  width: 100%;
                                "
                              >
                                <span v-if="notif.type == 2" class="fs-12"
                                  >Akun
                                  <span class="bold text-blue">{{
                                    notif.key
                                  }}</span>
                                  mengunggah {{ notif.value }} posting
                                  baru</span
                                >
                                <span v-else class="fs-12"
                                  >Kata
                                  <span class="bold text-blue">{{
                                    notif.key
                                  }}</span>
                                  muncul pada {{ notif.value }} posting
                                  baru</span
                                >
                              </a>
                              <span
                                style="line-height: 20px; font-size: 10px"
                                class="pull-right time p-t-0"
                                >{{
                                  notif.timestamp.$date | date_time_to_indo
                                }}</span
                              >
                            </div>
                          </div>
                        </div>
                        <!-- START Notification Item Right Side-->
                        <div
                          class="option bg-white"
                          data-toggle="tooltip"
                          data-placement="left"
                          title="mark as read"
                        >
                          <a href="#" class="mark" />
                        </div>
                        <!-- END Notification Item Right Side-->
                      </div>
                      <!-- END Notification Item-->
                    </div>
                  </div>
                  <!-- START Notification Footer-->
                  <div class="notification-footer text-center">
                    <a
                      href="javascript:void(0)"
                      class=""
                      @click="showAllNotification"
                      ><i class="bi bi-eye" /> Lihat semua</a
                    >
                    <a
                      v-if="data_notif"
                      data-toggle="refresh"
                      class="portlet-refresh text-black pull-right"
                      href="javascript:void(0)"
                      @click="markRead"
                    >
                      <i class="bi bi-check" /> Tandai semua sudah dibaca
                    </a>
                  </div>
                  <!-- START Notification Footer-->
                  <!-- END Notification Body-->
                </div>
                <!-- END Notification -->
              </div>
              <!-- END Notification Dropdown -->
            </div>
          </li>
        </ul>
        <!-- END NOTIFICATIONS LIST -->
        <!-- START User Info -->
        <div class="dropdown pull-right d-lg-block">
          <button
            class="profile-dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            aria-label="profile dropdown"
            @click="btnToggleHeader"
            id="headerDD"
          >
            <span class="thumbnail-wrapper d32 circular inline">
              <img
                src="/assets/img/profiles/default.jpg"
                alt=""
                data-src="/assets/img/profiles/default.jpg"
                data-src-retina="/assets/img/profiles/default.jpg"
                width="32"
                height="32"
              />
            </span>
          </button>
          <div
            class="dropdown-menu dropdown-menu-right profile-dropdown"
            role="menu"
          >
            <a href="#" class="dropdown-item"
              ><span
                >Hallo, <b>{{ nama_user.substring(0, 20) }}</b></span
              ></a
            >
            <div class="dropdown-divider" />
            <router-link to="/profile" class="dropdown-item">
              Profile
            </router-link>
            <a href="#" @click.prevent="startTour" class="dropdown-item"
              >Start Tour</a
            >
            <a href="#" @click="logout" class="dropdown-item">Logout</a>
          </div>
        </div>
        <!-- END User Info -->
      </div>
    </div>
    <!-- END HEADER -->
    <!-- START PAGE CONTENT WRAPPER -->
    <main-content />
    <!-- END PAGE CONTENT WRAPPER -->

    <modal-dynamic-component
      v-if="show_modal"
      :key="modal_key"
      :modal="data_modal"
      modal_id="show-all-notification"
    />
  </div>
</template>

<script>
import $ from "jquery";
import MainContent from "@/views/layout/content.vue";
import loader_component from "@/views/components/loader.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import header_notification from "@/views/components/header_notification.vue";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;
import gp from "@/plugins/generalPlugins.js";
import { isMobile } from "mobile-device-detect";
import moment from "moment";
import cookie from "js-cookie";

var icon_sources = [];
icon_sources["google"] = "bi bi-google";
icon_sources["facebook"] = "bi bi-facebook";
icon_sources["twitter"] = "bi bi-twitter";
icon_sources["instagram"] = "bi bi-instagram";
icon_sources["youtube"] = "bi bi-youtube";
icon_sources["news"] = "bi bi-newspaper";
icon_sources["blog"] = "bi bi-rss";
icon_sources["forum"] = "bi bi-chat-dots-fill";

export default {
  name: "ContentLayout",
  components: {
    "main-content": MainContent,
    "loader-component": loader_component,
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      theme: this.$store.getters.theme
        ? this.$store.getters.theme
        : "light-mode",
      nama_user: this.$store.getters.user.fullname,
      nama_proyek: this.$store.getters.user.project.project_detail.name,
      logo_proyek: this.$store.getters.user.project.project_detail.logo,
      socket_connected: false,
      new_notif: false,
      is_loading: false,
      data_notif: null,
      icon_sources: icon_sources,
      show_modal: false,
      data_modal: {},
      modal_key: 0,
      is_mobile: isMobile,
      id_project: this.$store.getters.user.id_project,
      project_expire: null,
    };
  },
  created() {
    const app = document.getElementById("apps");
    if (app) {
      if (this.theme == "light-mode") {
        app.classList.remove("dark-mode");
        app.classList.add("light-mode");
      } else {
        app.classList.remove("light-mode");
        app.classList.add("dark-mode");
      }
    }
  },
  methods: {
    changeTheme: function(theme) {
      this.theme = theme;
      const app = document.getElementById("apps");
      if (app) {
        if (this.theme == "light-mode") {
          app.classList.remove("dark-mode");
          app.classList.add("light-mode");
        } else {
          app.classList.remove("light-mode");
          app.classList.add("dark-mode");
        }
      }
      this.$store.dispatch("set_theme", this.theme);
      cookie.set("medmon_theme", this.theme);
    },
    btnToggleHeader: function(event) {
      var tag = $(event.target).prop("tagName");
      var dd;
      if (tag == "IMG") {
        dd = $(event.target)
          .parent()
          .parent()
          .next();
      } else {
        dd = $(event.target).next();
      }
      var display = dd.css("display");
      if (display == "none") {
        dd.slideDown("fast");
      } else {
        dd.slideUp("fast");
      }
    },
    toggleNotif: function(event) {
      var tag = $(event.target).prop("tagName");
      var sibling;
      let is_dropdown_show = $("#notifDropdownMenu").hasClass("show");
      this.new_notif = false;

      if (is_dropdown_show) {
        this.is_loading = false;
        $(".dropdown-menu").slideUp("fast");
        $("#notifDropdownMenu").removeAttr("style");
      } else {
        let api =
          process.env.VUE_APP_API_URL + "notifications/" + this.id_project;
        this.is_loading = true;
        this.$http
          .get(api)
          .then((response) => {
            if (response.status == 200) {
              this.data_notif = response.data;
            } else {
              this.data_notif = null;
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.is_loading = false;
          });

        $("#notifDropdownMenu").slideDown("fast");
        if (tag == "SPAN" || tag == "I") {
          sibling = $(event.target)
            .parent()
            .next();
        } else {
          sibling = $(event.target).next();
        }
        var style =
          "will-change: transform; position: absolute; transform: translate3d(-300px, 30px, 0px); top: 0px; left: 0px;";
        sibling.attr("x-placement", "bottom-start");
        sibling.attr("style", style);
        sibling.addClass("show");
        sibling.parent().addClass("show");
      }
    },
    logout: function() {
      event.preventDefault();
      this.$store.dispatch("logout").then(() => {
        let ref = encodeURI(btoa("logout"));
        let teks = encodeURI(btoa("Anda berhasil keluar dari sistem."));
        let title = encodeURI(btoa("Berhasil!"));
        this.$router.push({
          path: "login",
          query: { log: teks, ref: ref, log_t: title },
        });
      });
    },
    notifAction: function(index) {
      $(event.target)
        .closest(".notification-item")
        .removeClass("unread");
      let api = process.env.VUE_APP_API_URL + "read-notifications";
      let param_notif = {
        _id: this.data_notif[index]._id.$oid,
      };
      this.$http.post(api, param_notif);
      $(".dropdown-menu").slideUp("fast");
      $("#notifDropdownMenu").removeAttr("style");
      let notif = this.data_notif[index];
      let params = {
        q: notif.key,
      };
      this.$router.push({ path: "/posts", query: params });
    },
    showAllNotification: function() {
      this.data_modal.title = "Pemberitahuan";
      this.data_modal.subtitle = "Semua Pemberitahuan";
      this.data_modal.component = header_notification;
      this.show_modal = true;
      this.modal_key++;
    },
    markRead: function() {
      let api = process.env.VUE_APP_API_URL + "read-all-notifications";
      let param = {
        id_project: this.id_project,
      };

      this.$http.post(api, param).then((response) => {
        if (response.status == 200) {
          $("#notification-center").click();
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Semua pemberitahuan ditandai sebagai sudah dibaca!',
              position: "top",
              timeout: 5000,
              type: "success",
            })
            .show();
        }
      });
    },
    isProjectExpire: function() {
      if ("project" in this.$store.getters.user) {
        if ("project_detail" in this.$store.getters.user.project) {
          let status = this.$store.getters.user.project.project_detail.status;
          let project_end = this.$store.getters.user.project.project_detail.periode_to;
          let today = moment();
          let date_end = moment(project_end);
          let day_remain = date_end.diff(today, "days");
          if (status == 0) {
            this.project_expire = -1;
            return true;
          } else {
            this.project_expire = day_remain;
            if (day_remain <= 7) {
              return true;
            }
          }
        }
      }

      return false;
    },
    startTour: function() {
      this.$tours["myTour"].start();
    },
  },
  sockets: {
    trigger_project: function() {
      this.socket_connected = true;
      this.$socket.emit("init_project", this.id_project);
    },
    notification: function(data) {
      this.new_notif = true;

      let dynamic_word = "Kata";
      let akun;
      try {
        akun = Object.entries(data.accounts).length;
      } catch (e) {
        akun = 0;
      }
      let kata;
      try {
        kata = Object.entries(data.words).length;
      } catch (e) {
        kata = 0;
      }
      if (akun > 0 && kata > 0) {
        dynamic_word = "Akun dan Kata";
      } else if (akun > 0 && kata == 0) {
        dynamic_word = "Akun";
      } else if (akun == 0 && kata > 0) {
        dynamic_word = "Kata";
      }

      let msg = dynamic_word + " yang ditandai muncul pada posting terbaru.";
      let msg_html =
        '<i class="bi bi-bell"></i> <b>Pemberitahuan!</b> <br> ' +
        dynamic_word +
        " yang ditandai muncul pada posting terbaru.";

      $("body")
        .pgNotification({
          style: "bar",
          message: msg_html,
          position: "top-right",
          timeout: 5000,
          type: "success",
        })
        .show();

      let events = {
        onerror: function() {
          console.log("Custom error event was called");
        },
        onclick: function() {
          console.log("Custom click event was called");
        },
        onclose: function() {
          console.log("Custom close event was called");
        },
        onshow: function() {
          console.log("Custom show event was called");
        },
      };

      this.$notification.show("Online Media Monitoring", { body: msg }, events);
    },
  },
  filters: {
    date_time_to_indo: function(tanggal) {
      return gp.dateTimeID(tanggal);
    },
  },
  computed: {
    project_expire_message: function() {
      let msg = "";
      if (this.project_expire > 0) {
        msg =
          "Masa aktif project akan berakhir dalam " +
          this.project_expire +
          " hari!";
      } else if (this.project_expire == 0) {
        msg = "Masa aktif project akan berakhir hari ini!";
      } else {
        msg = "Masa aktif project sudah berakhir!";
      }
      return msg;
    },
  },
  mounted: function() {
    $(".dropdown-menu a").on("click", function() {
      $(".dropdown-menu").css("display", "none");
    });

    $(document).on("click", function(event) {
      var $trigger = $("#headerDD");
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".dropdown-menu").slideUp("fast");
        $("#notifDropdownMenu").removeAttr("style");
      }
    });
  },
};
</script>

<style>
@import "../../../public/assets/plugins/bootstrap-social/bootstrap-social.css";
.notification-panel .notification-body .notification-item {
  margin-left: 10px !important;
}
</style>
